export const fr = {
    'card-information.header.label': 'informations sur la carte',
    'card.number.placeholder': '1234 1234 1234 1234',
    'card.number.aria-label': 'Numéro de carte',
    'card.number.errors.required': 'Le numéro de carte est requis',
    'card.number.errors.min-length': 'Le nombre minimum de chiffres est de 13',
    'card.number.errors.invalid-number': 'Numéro de carte invalide',
    'card.save.label': 'Enregistrer la carte',
    'card.saved-cards.choose-card.label': 'Choisissez la carte',
    'card.saved-cards.clear-card.label': 'Dégager',
    'card.saved-cards.saved-card.aria-label': 'La carte se terminant par',
    'card.billing-name.placeholder': 'Nom sur la carte',
    'card.billing-name.aria-label': 'Nom sur la carte',
    'card.billing-name.errors.required': 'Le nom complet est requis',
    'card.billing-name.errors.min-length': 'Le nom complet est trop court',
    'card.expiry.placeholder': 'MM / AA',
    'card.expiry.aria-label': "Date d'expiration",
    'card.expiry.errors.required': "La date d'expiration est requise",
    'card.expiry.errors.pattern': "Le format de la date d'expiration n'est pas valide (MM/AA)",
    'card.expiry.errors.expired': 'Votre carte est expirée',
    'card.cvc.placeholder': 'CVC',
    'card.cvc.aria-label': 'Code de sécurité',
    'card.cvc.errors.required': 'Le code de sécurité est requis',
    'card.cvc.errors.min-length': 'Le code de sécurité est trop court',
    'card.cvc.errors.max-length': 'Le code de sécurité est trop long',
    'billing-address.same-as-shipping.label': "L'adresse de facturation est la même que l'expédition",
    'billing-address.country.placeholder': 'Pays',
    'billing-address.country.aria-label': 'Pays',
    'billing-address.country.errors.required': 'Pays est requis',
    'billing-address.zip.placeholder': 'Code postal',
    'billing-address.zip.aria-label': 'Code postal',
    'billing-address.zip.errors.required': 'Code postal est requis',
    'billing-address.zip.errors.min-length': 'Code postal est trop court',
    'pay-button.label': 'Payer',
    'pay-button.aria-label': 'Payer',
    'payment-methods.card.label': 'Carte',
    'payment-methods.show-more.label': 'Montre plus',
    'payment-methods.show-less.label': 'Montrer moins',
    'payment-methods.paypal.label': 'PayPal',
    'payment-methods.paypal.aria-label': 'Payer avec PayPal',
    'payment-methods.klarna.label': 'Klarna',
    'payment-methods.klarna.aria-label': 'Payer avec Klarna',
    'payment-methods.applepay.label': 'Apple Pay',
    'payment-methods.applepay.aria-label': 'Payer avec Apple Pay',
    'payment-methods.googlepay.label': 'Google Pay',
    'payment-methods.googlepay.aria-label': 'Payer avec Google Pay',
    'payment-success-state.label': 'Paiement réussi',
    'redirect-note.label': 'Après avoir soumis votre commande, vous serez redirigé en toute sécurité pour finaliser votre achat.',
    'error.invalid_cvc': 'CVC Invalide',
    'error.authorization_required': 'Autorisation requise',
    'error.contact_card_issuer': "Contacter l'émetteur de carte",
    'error.unsupported_card': 'Unsupported Card',
    'error.insufficient_funds': 'Carte non prise en charge',
    'error.unsupported_currency': 'Devise non prise en charge',
    'error.card_rejected': 'Carte rejetée',
    'error.expired_card': 'Carte expirée',
    'error.suspected_fraud': 'Fraude suspectée',
    'error.general_decline': 'Déclin général',
    'error.incorrect_number': 'Numéro incorrect',
    'error.incorrect_pin': 'Épingle incorrecte',
    'error.invalid_address': 'Adresse Invalide',
    'error.invalid_card_or_account': 'Carte ou compte Invalide',
    'error.invalid_amount': 'Montant Invalide',
    'error.invalid_date': 'Date Invalide',
    'error.lost_restricted_or_stolen_card': 'Carte perdue, restreinte ou volée',
    'error.blocked_list': 'Liste bloquée',
    'error.not_permitted': 'Pas permis',
    'error.offline_or_online_pin_required': 'Code PIN hors ligne ou en ligne requis',
    'error.pin_retry_exceeded': 'Nouvelle tentative de broche dépassée',
    'error.processing_error': 'Erreur de traitement',
    'error.withdrawal_count_limit_exceeded': 'Limite du nombre de retraits dépassée',
    'error.unknown': 'Erreur inconnue',
    'error.fraud': 'Fraude',
    'error.three_d_secure': 'Échec de la 3DS',
    'error.custom_rule': 'Règle personnalisée',
};
export default fr;
//# sourceMappingURL=fr.translation.js.map